<template>
    <div>
        <v-spa-label id="activity-form-calendar_event_id" :label="$t('form.calendar_event.label')"></v-spa-label>
        
        <div v-if="! displayForm" @click="relink">
            <div class="cursor-pointer mt-4 py-2 px-4 bg-white border-l-4 border-[#54b738] rounded">
                <div class="flex items-center">
                    <i class="mr-6 text-[#54b738] text-xl fal fa-check-circle"></i>
                    <span class="text-sm font-thin text-gray-600">
                        <p>
                            {{ $t('modals.activity.already_linked_to_planning') }}
                        </p>
                    </span>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="relative h-[38px] border border-gray-300 rounded" v-if="predictions == 'loading'">
                <v-spa-loader></v-spa-loader>
            </div>

            <div v-if="predictions && predictions !== 'loading'">
                <div class="px-4 py-2 mt-2 bg-white border-l-4 border-red-600 rounded" v-if="predictions.length == 0">
                    <div class="flex items-center">
                        <i class="mr-6 text-xl text-red-600 fal fa-exclamation-circle"></i>
                        <span class="text-sm font-thin text-gray-600">
                            <p>
                                {{ $t('form.calendar_event.empty') }}
                            </p>
                        </span>
                    </div>
                </div>
                <select v-else :class="$spa.css.form.select" id="activity-form-calendar_event_id" v-model="form.calendar_event_id">
                    <option :value="null">{{ $t('form.calendar_event.null') }}</option>
                    <option :value="prediction.id" v-for="prediction in predictions" :key="prediction.id">
                        {{ prediction.prediction_title }}
                    </option>
                </select>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        props: {
            activity: {
                required: true,
            },
            form: {
                required: true
            }
        },
        data() {
            return {
                predictions: null,
                displayForm: true
            }
        },
        computed: {
            alreadyLinked()
            {
                return this.activity && this.activity.calendar_events_ids && this.activity.calendar_events_ids.length > 0;
            }
        },
        methods: {
            relink() 
            {
                this.get();
                this.displayForm = true;
            },
            
            async get()
            {
                this.predictions = 'loading';

                let data = {
                    start: `${this.form.day} ${this.form.starts_at}:00`,
                    end: `${this.form.day} ${this.form.ends_at}:00`,
                    users: this.form.user ? this.form.user.id : null,
                    worksites: this.form.worksite ? this.form.worksite.uuid : null,
                };

                let {predictions} = await window.Planning.endpoints.calendarEvent.predictions(data);
                this.predictions = predictions;

                this.form.calendar_event_id = null;
                
                if ( this.predictions.length > 0 && (! this.form.calendar_event_id || ! this.predictions.some(p => p.id == this.form.calendar_event_id)) ) {
                    this.form.calendar_event_id = this.predictions[0].id;
                }
            }
        },
        created()
        {
            if ( this.alreadyLinked ) {
                this.displayForm = false;
            } else {
                this.get();
            }
        }
    }
</script>